const systems = {
  "arab":     "٠١٢٣٤٥٦٧٨٩",
  "arabext":  "۰۱۲۳۴۵۶۷۸۹",
  "bali":     "᭐᭑᭒᭓᭔᭕᭖᭗᭘᭙",
  "beng":     "০১২৩৪৫৬৭৮৯",
  "deva":     "०१२३४५६७८९",
  "fullwide": "０１２３４５６７８９",
  "gujr":     "૦૧૨૩૪૫૬૭૮૯",
  "guru":     "੦੧੨੩੪੫੬੭੮੯",
  "hanidec":  "〇一二三四五六七八九",
  "khmr":     "០១២៣៤៥៦៧៨៩",
  "knda":     "೦೧೨೩೪೫೬೭೮೯",
  "laoo":     "໐໑໒໓໔໕໖໗໘໙",
  "latn":     "0123456789",
  "limb":     "᥆᥇᥈᥉᥊᥋᥌᥍᥎᥏",
  "mlym":     "൦൧൨൩൪൫൬൭൮൯",
  "mong":     "᠐᠑᠒᠓᠔᠕᠖᠗᠘᠙",
  "mymr":     "၀၁၂၃၄၅၆၇၈၉",
  "orya":     "୦୧୨୩୪୫୬୭୮୯",
  "tamldec":  "௦௧௨௩௪௫௬௭௮௯",
  "telu":     "౦౧౨౩౪౫౬౭౮౯",
  "thai":     "๐๑๒๓๔๕๖๗๘๙",
  "tibt":     "༠༡༢༣༤༥༦༧༨༩",
}

export const [ _, localeDecimal ] = 1.1.toLocaleString()
const decimals = [ /* Arabic/Persian: */ '٫', '.', localeDecimal ]
const table = {}

Object.keys(systems).forEach(key => {
  const numerals = [ ...systems[key] ]
  numerals.forEach((numeral, index) =>
    table[numeral] = String(index)
  )
})

export const addDecimal = decimal => {
  const [ char ] = decimal
  table[char] = '.'
}

decimals.forEach(addDecimal)

export const convert = str => [ ...str ].map(c => table[c]).join('')
